export const WEATHER_PRESETS = {
    clear: { cloud: 0.18, overcast: 0, rain: 0, snow: 0, fog: 0.12, storm: 0, wind: 0.45, temp: 31 },
    cloudy: { cloud: 0.62, overcast: 0.45, rain: 0, snow: 0, fog: 0.22, storm: 0, wind: 0.75, temp: 29 },
    rain: { cloud: 0.88, overcast: 0.82, rain: 0.7, snow: 0, fog: 0.45, storm: 0, wind: 1.0, temp: 26 },
    storm: { cloud: 1.0, overcast: 1.0, rain: 1.0, snow: 0, fog: 0.55, storm: 1, wind: 1.8, temp: 24 },
    fog: { cloud: 0.45, overcast: 0.6, rain: 0, snow: 0, fog: 1.0, storm: 0, wind: 0.2, temp: 23 },
    heatwave: { cloud: 0.1, overcast: 0.12, rain: 0, snow: 0, fog: 0.2, storm: 0, wind: 0.3, temp: 35 },
    snow: { cloud: 0.85, overcast: 0.72, rain: 0, snow: 1, fog: 0.5, storm: 0, wind: 0.55, temp: -2 },
};
